(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-landing-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.home__control--stack').forEach((stack) => {
      const list = stack.querySelector('.home__control--group');
      const btnUp = stack.querySelector('.home__control--button[data-label="up"]');
      const btnDown = stack.querySelector('.home__control--button[data-label="down"]');
      if (!list || !btnUp || !btnDown) return;

      const radios = Array.from(list.querySelectorAll('input.home__control--radio[type="radio"]'));

      const getCheckedIndex = () => radios.findIndex((r) => r.checked);

      const setChecked = (idx) => {
        if (idx < 0 || idx >= radios.length) return;
        radios[idx].checked = true;
        radios[idx].dispatchEvent(new Event('change', { bubbles: true }));
      };

      btnDown.addEventListener('click', () => {
        const i = getCheckedIndex();
        // if none selected yet -> select first
        setChecked(i === -1 ? 0 : Math.min(i + 1, radios.length - 1));
      });

      btnUp.addEventListener('click', () => {
        const i = getCheckedIndex();
        // if none selected yet -> select last
        setChecked(i === -1 ? radios.length - 1 : Math.max(i - 1, 0));
      });
    });
  });
  document.addEventListener('DOMContentLoaded', () => {
    const unit = document.querySelector('[data-unit-image]');
    const group = document.querySelector('.home__control--group');
    if (!unit || !group) return;

    const noneRadio = document.getElementById('none'); // your "reset" radio
    const radios = Array.from(group.querySelectorAll('input.home__control--radio[type="radio"]'));
    const panelImgs = Array.from(unit.querySelectorAll('.home__panel-image'));

    function showMain() {
      unit.classList.remove('is-panel-active');
      panelImgs.forEach((img) => img.classList.remove('is-active'));
    }

    function showPanel(panelId) {
      const img = unit.querySelector(`.home__panel-image[data-panel-image="${panelId}"]`);
      if (!img) return showMain();

      unit.classList.add('is-panel-active');
      panelImgs.forEach((i) => i.classList.toggle('is-active', i === img));
    }

    // panel radios
    radios.forEach((r) => {
      r.addEventListener('change', () => {
        if (!r.checked) return;
        // prefer data-panel if you add it; fallback to id
        const panelId = r.dataset.panel || r.id;
        showPanel(panelId);
      });
    });

    // none -> back to slideshow
    if (noneRadio) {
      noneRadio.addEventListener('change', () => {
        if (noneRadio.checked) showMain();
      });
    }

    // initial state
    const checked = radios.find((r) => r.checked);
    if (checked) showPanel(checked.dataset.panel || checked.id);
    else showMain();
  });

  document.addEventListener('DOMContentLoaded', () => {
    const mq = window.matchMedia('(max-width: 989px)');

    // tuning
    const DOMINANCE = 1.1; // horizontal must dominate vertical
    const LOCK_PX = 10; // px before we lock direction
    const DRAG_MAX = 0.35; // max drag = 35% of panel width
    const TRIGGER_PROGRESS = 0.55; // trigger when you dragged 55% of max

    // image + panel sync
    const IMAGE_RATIO = 1.0; // 1.0 = perfectly in sync with panel
    const FADE_MAX_IMG = 0.18; // image fades up to 18% while dragging
    const FADE_MAX_PANEL = 0.12; // panel fades up to 12% while dragging
    const OUT_FADE_IMG = 0.25; // fade when completing swipe
    const OUT_FADE_PANEL = 0.2;

    const supportsPointer = 'PointerEvent' in window;

    function attachDragSwipe(surface, opts) {
      if (!surface) return;

      let sx = 0,
        sy = 0,
        tracking = false;
      let locked = null; // 'x' or 'y'
      let activeEl = null;
      let activeImgEls = [];

      const clamp = (v, min, max) => Math.max(min, Math.min(v, max));

      const getPoint = (e) => {
        if (e.touches && e.touches.length) return e.touches[0];
        if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0];
        return e;
      };

      const setPanel = (x, opacity) => {
        if (!activeEl) return;
        activeEl.style.transform = `translateX(${x}px)`;
        activeEl.style.opacity = String(opacity);
      };

      const setImage = (x, opacity) => {
        if (!activeImgEls.length) return;
        activeImgEls.forEach((el) => {
          el.style.transform = `translateX(${x}px)`;
          el.style.opacity = String(opacity);
        });
      };

      const clearAll = () => {
        if (activeEl) {
          activeEl.style.transition = '';
          activeEl.style.transform = '';
          activeEl.style.opacity = '';
          activeEl.style.willChange = '';
        }
        activeImgEls.forEach((el) => {
          el.style.transition = '';
          el.style.transform = '';
          el.style.opacity = '';
          el.style.willChange = '';
        });
        activeEl = null;
        activeImgEls = [];
        locked = null;
      };

      const start = (e) => {
        if (!opts.enabled()) return;

        // ignore mouse/trackpad
        if (supportsPointer && e.pointerType === 'mouse') return;

        // ignore pinch
        if (e.touches && e.touches.length > 1) return;

        activeEl = opts.getActiveEl();
        activeImgEls = opts.getImageEls();
        if (!activeEl) return;

        const p = getPoint(e);
        sx = p.clientX;
        sy = p.clientY;
        tracking = true;
        locked = null;

        activeEl.style.willChange = 'transform, opacity';
        activeEl.style.transition = 'none';

        activeImgEls.forEach((el) => {
          el.style.willChange = 'transform, opacity';
          el.style.transition = 'none';
        });

        if (supportsPointer && surface.setPointerCapture && e.pointerId != null) {
          try {
            surface.setPointerCapture(e.pointerId);
          } catch (_) {}
        }
      };

      const move = (e) => {
        if (!tracking || !activeEl) return;
        if (!opts.enabled()) return;

        const p = getPoint(e);
        const dx = p.clientX - sx;
        const dy = p.clientY - sy;

        // direction lock
        if (!locked) {
          if (Math.abs(dx) < LOCK_PX && Math.abs(dy) < LOCK_PX) return;
          locked = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        }

        // if horizontal intent, stop page scroll (touch only)
        if (locked === 'x' && e.cancelable) e.preventDefault();
        if (locked !== 'x') return;

        const w = activeEl.getBoundingClientRect().width || 1;
        const max = w * DRAG_MAX;

        const clampedDx = clamp(dx, -max, max);
        const progress = Math.min(1, Math.abs(clampedDx) / max);

        setPanel(clampedDx, 1 - progress * FADE_MAX_PANEL);
        setImage(clampedDx * IMAGE_RATIO, 1 - progress * FADE_MAX_IMG);
      };

      const end = (e) => {
        if (!tracking) return;
        tracking = false;

        if (!opts.enabled() || !activeEl) {
          clearAll();
          return;
        }

        // if vertical scroll gesture, abort
        if (locked === 'y') {
          clearAll();
          return;
        }

        const p = getPoint(e);
        const dx = p.clientX - sx;
        const dy = p.clientY - sy;

        const horizontalEnough = Math.abs(dx) > Math.abs(dy) * DOMINANCE;

        const w = activeEl.getBoundingClientRect().width || 1;
        const max = w * DRAG_MAX;
        const clampedDx = clamp(dx, -max, max);
        const progress = Math.min(1, Math.abs(clampedDx) / max);

        const isSwipe = horizontalEnough && progress >= TRIGGER_PROGRESS;

        const OUT = w + 40;

        const snapBack = () => {
          activeEl.style.transition = 'transform 180ms ease, opacity 180ms ease';
          setPanel(0, 1);

          activeImgEls.forEach((el) => {
            el.style.transition = 'transform 180ms ease, opacity 180ms ease';
          });
          setImage(0, 1);

          activeEl.addEventListener('transitionend', clearAll, { once: true });
        };

        if (!isSwipe) return snapBack();

        const left = dx < 0;
        if (left && !opts.canNext()) return snapBack();
        if (!left && !opts.canPrev()) return snapBack();

        // slide current out (panel + image)
        activeEl.style.transition = 'transform 180ms ease, opacity 180ms ease';
        setPanel(left ? -OUT : OUT, 1 - OUT_FADE_PANEL);

        activeImgEls.forEach((el) => {
          el.style.transition = 'transform 180ms ease, opacity 180ms ease';
        });
        setImage((left ? -OUT : OUT) * IMAGE_RATIO, 1 - OUT_FADE_IMG);

        activeEl.addEventListener(
          'transitionend',
          () => {
            // trigger your existing logic (buttons)
            if (left) opts.goNext();
            else opts.goPrev();

            // animate incoming panel + image in
            requestAnimationFrame(() => {
              const incomingPanel = opts.getActiveEl();
              const incomingImgs = opts.getImageEls();
              const OUT2 = OUT;

              if (incomingPanel) {
                incomingPanel.style.willChange = 'transform, opacity';
                incomingPanel.style.transition = 'none';
                incomingPanel.style.transform = `translateX(${left ? OUT2 : -OUT2}px)`;
                incomingPanel.style.opacity = String(1 - OUT_FADE_PANEL);
              }

              incomingImgs.forEach((el) => {
                el.style.willChange = 'transform, opacity';
                el.style.transition = 'none';
                el.style.transform = `translateX(${(left ? OUT2 : -OUT2) * IMAGE_RATIO}px)`;
                el.style.opacity = String(1 - OUT_FADE_IMG);
              });

              // force reflow
              incomingPanel && incomingPanel.getBoundingClientRect();

              if (incomingPanel) {
                incomingPanel.style.transition = 'transform 200ms ease, opacity 200ms ease';
                incomingPanel.style.transform = 'translateX(0px)';
                incomingPanel.style.opacity = '1';
              }

              incomingImgs.forEach((el) => {
                el.style.transition = 'transform 200ms ease, opacity 200ms ease';
                el.style.transform = 'translateX(0px)';
                el.style.opacity = '1';
              });

              const cleanup = () => {
                if (incomingPanel) {
                  incomingPanel.style.transition = '';
                  incomingPanel.style.transform = '';
                  incomingPanel.style.opacity = '';
                  incomingPanel.style.willChange = '';
                }
                incomingImgs.forEach((el) => {
                  el.style.transition = '';
                  el.style.transform = '';
                  el.style.opacity = '';
                  el.style.willChange = '';
                });
              };

              if (incomingPanel) incomingPanel.addEventListener('transitionend', cleanup, { once: true });
              else setTimeout(cleanup, 220);
            });

            clearAll();
          },
          { once: true }
        );
      };

      const cancel = () => {
        tracking = false;
        clearAll();
      };

      if (supportsPointer) {
        surface.addEventListener('pointerdown', start, { passive: true });
        surface.addEventListener('pointermove', move, { passive: true }); // pointer uses touch-action
        surface.addEventListener('pointerup', end, { passive: true });
        surface.addEventListener('pointercancel', cancel, { passive: true });
      } else {
        surface.addEventListener('touchstart', start, { passive: true });
        surface.addEventListener('touchmove', move, { passive: false }); // preventDefault needs passive:false
        surface.addEventListener('touchend', end, { passive: true });
        surface.addEventListener('touchcancel', cancel, { passive: true });
      }
    }

    document.querySelectorAll('.home__control--stack').forEach((stack) => {
      const group = stack.querySelector('.home__control--group');
      const btnUp = stack.querySelector('.home__control--button[data-label="up"]');
      const btnDown = stack.querySelector('.home__control--button[data-label="down"]');
      const noneRadio = stack.querySelector('#none');

      if (!group || !btnUp || !btnDown) return;

      const radios = Array.from(group.querySelectorAll('input.home__control--radio[type="radio"]'));
      if (!radios.length) return;

      const hero = stack.closest('.home__unit--hero');
      const unit = hero ? hero.querySelector('[data-unit-image]') : null;

      // one surface covers image + gap + panel
      const surface = stack.closest('.home__content');

      const getCheckedIndex = () => radios.findIndex((r) => r.checked);

      const enabled = () => {
        if (!mq.matches) return false;
        if (noneRadio && noneRadio.checked) return false;
        return getCheckedIndex() !== -1;
      };

      const getActiveEl = () => {
        const checked = radios.find((r) => r.checked);
        return checked ? checked.closest('.home__control--radio-container') : null;
      };

      const getImageEls = () => {
        if (!unit) return [];
        const panel = unit.querySelector('.home__panel-images');
        return [panel].filter(Boolean);
      };

      const canNext = () => {
        const i = getCheckedIndex();
        return i !== -1 && i < radios.length - 1;
      };

      const canPrev = () => {
        const i = getCheckedIndex();
        return i > 0;
      };

      const goNext = () => btnDown.click();
      const goPrev = () => btnUp.click();

      // cleanup if user taps/changes
      radios.forEach((r) =>
        r.addEventListener('change', () => {
          const el = getActiveEl();
          if (el) {
            el.style.transition = '';
            el.style.transform = '';
            el.style.opacity = '';
            el.style.willChange = '';
          }
          getImageEls().forEach((im) => {
            im.style.transition = '';
            im.style.transform = '';
            im.style.opacity = '';
            im.style.willChange = '';
          });
        })
      );

      attachDragSwipe(surface, { enabled, getActiveEl, getImageEls, canNext, canPrev, goNext, goPrev });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var configurationState = window.ProductConfigurationGroupState;
    if (!(configurationState instanceof Map)) {
      configurationState = new Map();
      window.ProductConfigurationGroupState = configurationState;
    }

    function clampQuantity(input, value) {
      var min = Number(input.min || 0);
      var max = Number(input.max || 99);
      var quantity = Number.parseInt(value, 10);

      if (!Number.isFinite(quantity)) quantity = min;
      return Math.min(max, Math.max(min, quantity));
    }

    function createConfigurationSelect(card, selected, index) {
      var select = document.createElement('select');
      select.className = 'product__configuration-select configuration-group__select';
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');

      var emptyOption = document.createElement('option');
      emptyOption.value = '';
      emptyOption.selected = !selected;
      select.appendChild(emptyOption);

      var variantOption = document.createElement('option');
      variantOption.value = 'configuration-' + card.dataset.configurationKey + '-' + index;
      variantOption.dataset.variantId = card.dataset.variantId || '';
      variantOption.dataset.variantPrice = card.dataset.variantPrice || '0';
      variantOption.dataset.persistenceCode = card.dataset.configurationKey + '-' + index;
      variantOption.textContent = card.dataset.variantTitle || 'Zusatzprodukt';
      variantOption.selected = selected;
      select.appendChild(variantOption);

      return select;
    }

    function updateConfigurationGroupStatus(group) {
      if (!group) return;

      var total = Array.prototype.slice
        .call(group.querySelectorAll('[data-configuration-quantity]'))
        .reduce(function (sum, input) {
          return sum + (Number.parseInt(input.value, 10) || 0);
        }, 0);

      var status = group.querySelector('[data-configuration-group-status]');
      if (!status) return;

      status.textContent = total > 0 ? total + ' ausgewählt' : 'Optional';
    }

    function renderConfigurationProduct(card, requestedQuantity, notify) {
      var quantityInput = card.querySelector('[data-configuration-quantity]');
      var checkbox = card.querySelector('[data-configuration-checkbox]');
      var selectsContainer = card.querySelector('[data-configuration-selects]');
      if (!quantityInput || !checkbox || !selectsContainer) return;

      var quantity = checkbox.disabled ? 0 : clampQuantity(quantityInput, requestedQuantity);
      quantityInput.value = quantity;
      checkbox.checked = quantity > 0;
      card.classList.toggle('is-selected', quantity > 0);
      configurationState.set(card.dataset.configurationKey, quantity);

      selectsContainer.replaceChildren();
      var selectCount = Math.max(1, quantity);
      for (var index = 0; index < selectCount; index += 1) {
        selectsContainer.appendChild(createConfigurationSelect(card, quantity > 0, index));
      }

      updateConfigurationGroupStatus(card.closest('[data-configuration-group]'));

      if (notify) {
        var driver = selectsContainer.querySelector('.configuration-group__select');
        if (driver) driver.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function initializeConfigurationGroups(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var initializedCards = [];

      scope.querySelectorAll('[data-configuration-product]').forEach(function (card) {
        if (card.dataset.configurationInitialized === 'true') return;
        card.dataset.configurationInitialized = 'true';

        var quantityInput = card.querySelector('[data-configuration-quantity]');
        if (!quantityInput) return;

        var storedQuantity = configurationState.has(card.dataset.configurationKey)
          ? configurationState.get(card.dataset.configurationKey)
          : quantityInput.value;

        renderConfigurationProduct(card, storedQuantity, false);
        initializedCards.push(card);
      });

      if (initializedCards.length > 0) {
        var firstDriver = initializedCards[0].querySelector('.configuration-group__select');
        if (firstDriver) firstDriver.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-configuration-quantity-step]');
      if (!button) return;

      event.preventDefault();
      var card = button.closest('[data-configuration-product]');
      var input = card && card.querySelector('[data-configuration-quantity]');
      if (!card || !input || input.disabled) return;

      var step = Number.parseInt(button.dataset.configurationQuantityStep, 10) || 0;
      renderConfigurationProduct(card, (Number.parseInt(input.value, 10) || 0) + step, true);
    });

    document.addEventListener('change', function (event) {
      var checkbox = event.target.closest('[data-configuration-checkbox]');
      if (checkbox) {
        var checkboxCard = checkbox.closest('[data-configuration-product]');
        var checkboxQuantity = checkboxCard.querySelector('[data-configuration-quantity]');
        var nextQuantity = checkbox.checked ? Math.max(1, Number.parseInt(checkboxQuantity.value, 10) || 0) : 0;
        renderConfigurationProduct(checkboxCard, nextQuantity, true);
        return;
      }

      var quantityInput = event.target.closest('[data-configuration-quantity]');
      if (quantityInput) {
        renderConfigurationProduct(quantityInput.closest('[data-configuration-product]'), quantityInput.value, true);
      }
    });

    document.addEventListener(
      'toggle',
      function (event) {
        var openedGroup = event.target;
        if (!openedGroup.matches || !openedGroup.matches('[data-configuration-group][open]')) return;

        var container = openedGroup.closest('[data-configuration-groups]');
        if (!container) return;
        container.querySelectorAll('[data-configuration-group][open]').forEach(function (group) {
          if (group !== openedGroup) group.open = false;
        });
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeConfigurationGroups(document);
      });
    } else {
      initializeConfigurationGroups(document);
    }

    document.addEventListener('product:section:updated', function (event) {
      initializeConfigurationGroups(event.target || document);
    });
  })();

  (function () {
    // -------------------------
    // Asset URLs aus Liquid-JSON lesen
    // -------------------------
    function getOfferAssets() {
      try {
        var el = document.querySelector('script[data-offer-assets]');
        if (!el) return {};
        return JSON.parse(el.textContent || '{}') || {};
      } catch (e) {
        return {};
      }
    }

    // =========================
    // Cart Snapshot
    // =========================
    async function fetchCartSnapshotSafe() {
      try {
        var res = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) return { items: [], lines: [] };

        var cart = await res.json();

        var items = (cart.items || [])
          .map(function (it) {
            var variantId = String(it.id || '').trim();
            var quantity = Number(it.quantity) || 0;
            if (!variantId || quantity <= 0) return null;
            return { variantId: variantId, quantity: quantity };
          })
          .filter(Boolean);

        var lines = (cart.items || [])
          .map(function (it) {
            var qty = Number(it.quantity) || 0;
            if (qty <= 0) return null;

            var title = String(it.product_title || it.title || 'Artikel').trim();
            var variantTitle = it.variant_title && it.variant_title !== 'Default Title' ? String(it.variant_title) : '';
            // nur ASCII-Trenner, damit es nirgendwo bei Copy/Paste/Parsern knallt
            var fullTitle = variantTitle ? title + ' - ' + variantTitle : title;

            var unitPriceCents = Number(it.final_price != null ? it.final_price : it.price || 0) || 0;
            var lineTotalCents =
              Number(it.final_line_price != null ? it.final_line_price : it.line_price || unitPriceCents * qty) || 0;

            return { title: fullTitle, qty: qty, unitPriceCents: unitPriceCents, lineTotalCents: lineTotalCents };
          })
          .filter(Boolean);

        return { items: items, lines: lines };
      } catch (e) {
        console.warn('[OFFER] cart.js failed', e);
        return { items: [], lines: [] };
      }
    }

    function mergeItemsByVariant(a, b) {
      var map = new Map();
      (a || []).concat(b || []).forEach(function (it) {
        var id = String(it.variantId || '').trim();
        var q = Number(it.quantity) || 0;
        if (!id || q <= 0) return;
        map.set(id, (map.get(id) || 0) + q);
      });
      return Array.from(map.entries()).map(function (pair) {
        return { variantId: pair[0], quantity: pair[1] };
      });
    }

    // =========================
    // CLICK: Angebot erstellen (neuer Tab)
    // =========================
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-offer-pdf]');
      if (!btn) return;

      e.preventDefault();

      var w = window.open('', '_blank');
      if (!w) {
        alert('Popup blockiert. Bitte Popups für diese Seite erlauben.');
        return;
      }

      w.document.open();
      w.document.write(
        '<!doctype html><meta charset="utf-8"><title>Angebot…</title>' +
          '<p style="font-family:system-ui;padding:20px">Erstelle Angebot…</p>'
      );
      w.document.close();

      (async function () {
        try {
          var data = await collectOfferData();

          console.log('[OFFER] cart permalink:', data.acceptUrl);
          console.log('[OFFER] checkoutUrl:', data.checkoutUrl);
          console.log('[OFFER] propertiesB64:', data.lineItemPropertiesB64);
          console.log('[OFFER] propertiesObj:', data.lineItemProperties);

          var html = buildOfferConfirmHtml(data);

          w.document.open();
          w.document.write(html);
          w.document.close();
          w.focus();
        } catch (err) {
          console.error('Offer error:', err);
          try {
            w.close();
          } catch (e2) {}
          alert('Angebot konnte nicht erzeugt werden. Details in der Konsole.');
        }
      })();
    });

    // =========================
    // Cookie/Storage helpers (für properties payload)
    // =========================
    function readCookie(name) {
      var escaped = String(name).replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
      var m = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }

    function pickFirstNonEmpty() {
      for (var i = 0; i < arguments.length; i++) {
        var v = arguments[i];
        if (typeof v === 'string' && v.trim() !== '') return v.trim();
      }
      return '';
    }

    // Base64URL (unicode-safe)
    function base64UrlEncodeUnicode(str) {
      var b64 = btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
          return String.fromCharCode(parseInt(p1, 16));
        })
      );
      return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }

    function read3FieldsFromBrowser() {
      var gc = pickFirstNonEmpty(
        readCookie('_shopify_gc'),
        sessionStorage.getItem('_consent_gc'),
        localStorage.getItem('_cdn_gc')
      );
      var wb = pickFirstNonEmpty(
        readCookie('_shopify_wb'),
        sessionStorage.getItem('_consent_wb'),
        localStorage.getItem('_cdn_wb')
      );
      var gb = pickFirstNonEmpty(
        readCookie('_shopify_gb'),
        sessionStorage.getItem('_consent_gb'),
        localStorage.getItem('_cdn_gb')
      );
      return { gc: gc, wb: wb, gb: gb };
    }

    function buildLineItemProperties() {
      var f = read3FieldsFromBrowser();
      var payload = {};
      function add(key, val) {
        if (val == null) return;
        var s = String(val).trim();
        if (s) payload[key] = s;
      }
      add('_gc', f.gc);
      add('_wb', f.wb);
      add('_gb', f.gb);
      return payload;
    }

    function buildLineItemPropertiesB64(payloadObj) {
      if (!payloadObj || typeof payloadObj !== 'object') return '';
      if (Object.keys(payloadObj).length === 0) return '';
      return base64UrlEncodeUnicode(JSON.stringify(payloadObj));
    }

    // =========================
    // Kontakt-Daten (Modal) lesen
    // =========================
    function readOfferContactData() {
      var checked = document.querySelector('input[name="qr_offer_contact"]:checked');
      var mode = checked ? checked.value : 'none';
      var enabled = mode === 'with_contact';
      if (!enabled) return { enabled: false };

      function get(sel) {
        var el = document.querySelector(sel);
        return (el && el.value ? el.value : '').trim();
      }

      var firstname = get('#qr-offer-firstname');
      var lastname = get('#qr-offer-lastname');

      return {
        enabled: true,
        company: get('#qr-offer-company'),
        firstname: firstname,
        lastname: lastname,
        name: [firstname, lastname].filter(Boolean).join(' '),
        email: get('#qr-offer-email'),
        address1: get('#qr-offer-address1'),
        zip: get('#qr-offer-zip'),
        city: get('#qr-offer-city'),
        country: get('#qr-offer-country'),
      };
    }

    function buildCheckoutPrefillQuery(contact) {
      if (!contact || !contact.enabled) return '';

      var params = new URLSearchParams();
      if (contact.email) params.set('checkout[email]', contact.email);

      if (contact.firstname) params.set('checkout[shipping_address][first_name]', contact.firstname);
      if (contact.lastname) params.set('checkout[shipping_address][last_name]', contact.lastname);

      if (contact.address1) params.set('checkout[shipping_address][address1]', contact.address1);
      if (contact.city) params.set('checkout[shipping_address][city]', contact.city);
      if (contact.country) params.set('checkout[shipping_address][country]', contact.country);
      if (contact.zip) params.set('checkout[shipping_address][zip]', contact.zip);

      return params.toString();
    }

    // =========================
    // Data collection
    // =========================
    async function collectOfferData() {
      var form =
        document.querySelector('form[action^="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action^="/cart"]') ||
        document.querySelector('form[action*="/cart"]');

      if (!form) throw new Error('Cart/Add form not found');

      var assets = getOfferAssets();
      var origin = window.location.origin;

      var formItems = readItemsFromForm(form);

      var productTitle =
        (
          (document.querySelector('.product__title') && document.querySelector('.product__title').textContent) ||
          ''
        ).trim() ||
        ((document.querySelector('h1') && document.querySelector('h1').textContent) || '').trim() ||
        'Produkt';

      var basePriceRaw =
        (document.querySelector('.product__price[data-variant-price]') &&
          document.querySelector('.product__price[data-variant-price]').dataset &&
          document.querySelector('.product__price[data-variant-price]').dataset.variantPrice) ||
        (document.querySelector('[data-variant-price]') &&
          document.querySelector('[data-variant-price]').dataset &&
          document.querySelector('[data-variant-price]').dataset.variantPrice) ||
        '0';

      var basePriceCents = parseInt(basePriceRaw, 10);
      var tentQty =
        parseInt(
          (document.querySelector('.quantity__input') && document.querySelector('.quantity__input').value) || '',
          10
        ) ||
        parseInt(
          (form.querySelector('input[name="quantity"]') && form.querySelector('input[name="quantity"]').value) || '1',
          10
        ) ||
        1;

      var selectedVariantText = readSelectedOptionsText();
      var wallLines = readWallsFromSelects(tentQty);
      var configurationLines = readConfigurationProducts(tentQty);

      var contact = readOfferContactData();
      var checkoutQuery = buildCheckoutPrefillQuery(contact);

      var lineItemProperties = buildLineItemProperties();
      var lineItemPropertiesB64 = buildLineItemPropertiesB64(lineItemProperties);

      var cartSnap = await fetchCartSnapshotSafe();
      var items = mergeItemsByVariant(cartSnap.items, formItems);

      var acceptUrl = buildCartPermalink(origin, items, {
        propertiesB64: lineItemPropertiesB64,
        checkoutQuery: checkoutQuery,
      });

      // Direkt in den Checkout springen: cart permalink + &checkout
      var checkoutUrl = buildCheckoutUrlFromAcceptUrl(acceptUrl);

      var now = new Date();
      var dateStr = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' }).format(now);
      var offerNo = makeOfferNumber(now);

      return {
        origin: origin,
        productTitle: productTitle,
        selectedVariantText: selectedVariantText,
        basePriceCents: Number.isFinite(basePriceCents) ? basePriceCents : 0,
        tentQty: tentQty,
        wallLines: wallLines,
        configurationLines: configurationLines,

        items: items,
        cartLines: cartSnap.lines,
        acceptUrl: acceptUrl,
        checkoutUrl: checkoutUrl,

        checkoutQuery: checkoutQuery,
        contact: contact,

        lineItemProperties: lineItemProperties,
        lineItemPropertiesB64: lineItemPropertiesB64,

        dateStr: dateStr,
        offerNo: offerNo,
        currency:
          window.Shopify && window.Shopify.currency && window.Shopify.currency.active
            ? window.Shopify.currency.active
            : 'EUR',
        locale: window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'de-DE',
        assets: {
          jsqr: assets.jsqr || '',
          jspdf: assets.jspdf || '',
          logo: assets.logo || '',
        },
      };
    }

    function readItemsFromForm(form) {
      var out = [];

      // Multi-line: items[n][id]
      var multi = form.querySelector('input[name="items[0][id]"]');
      if (multi) {
        var idInputs = Array.prototype.slice.call(form.querySelectorAll('input[name^="items["][name$="[id]"]'));
        idInputs.forEach(function (idInput) {
          var m = idInput.name.match(/^items\[(\d+)\]\[id\]$/);
          if (!m) return;
          var idx = m[1];

          var qtyInput = form.querySelector('input[name="items[' + idx + '][quantity]"]');
          var qty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;

          var variantId = String(idInput.value || '').trim();
          if (!variantId) return;

          out.push({ variantId: variantId, quantity: qty });
        });
        return out;
      }

      // Single
      var id =
        (form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').value) ||
        (form.querySelector('input[name="variant_id"]') && form.querySelector('input[name="variant_id"]').value) ||
        (form.querySelector('input[name="variantId"]') && form.querySelector('input[name="variantId"]').value) ||
        '';

      var qty2 =
        parseInt(
          (form.querySelector('input[name="quantity"]') && form.querySelector('input[name="quantity"]').value) || '1',
          10
        ) || 1;
      if (id) out.push({ variantId: String(id).trim(), quantity: qty2 });

      return out;
    }

    function readSelectedOptionsText() {
      var parts = [];
      Array.prototype.slice.call(document.querySelectorAll('.product__option-input:checked')).forEach(function (inp) {
        var val = String(inp.value || '').trim();
        if (val) parts.push(val);
      });
      return parts.join(' / ');
    }

    function readWallsFromSelects(tentQty) {
      var selects = Array.prototype.slice.call(
        document.querySelectorAll('.product__configuration-select:not(.configuration-group__select)')
      );
      var byVariant = new Map();

      selects.forEach(function (sel) {
        var opt = sel.selectedOptions && sel.selectedOptions[0];
        if (!opt) return;

        var variantId = opt.dataset ? opt.dataset.variantId : opt.getAttribute('data-variant-id');
        if (!variantId) return;

        var title = (opt.textContent || '').split('-')[0].trim() || 'Seitenwand';
        var unitPriceCents =
          parseInt((opt.dataset && opt.dataset.variantPrice) || opt.getAttribute('data-variant-price') || '0', 10) || 0;

        if (!byVariant.has(variantId))
          byVariant.set(variantId, { variantId: variantId, title: title, unitPriceCents: unitPriceCents, count: 0 });
        byVariant.get(variantId).count += 1;
      });

      return Array.from(byVariant.values()).map(function (r) {
        return {
          variantId: r.variantId,
          title: r.title,
          unitPriceCents: r.unitPriceCents,
          qty: r.count * tentQty,
        };
      });
    }

    function readConfigurationProducts(tentQty) {
      return Array.prototype.slice
        .call(document.querySelectorAll('[data-configuration-product]'))
        .map(function (card) {
          var quantityInput = card.querySelector('[data-configuration-quantity]');
          var quantityPerTent = Number.parseInt((quantityInput && quantityInput.value) || '0', 10) || 0;
          if (quantityPerTent <= 0) return null;

          return {
            variantId: card.dataset.variantId || '',
            groupLabel: card.dataset.groupLabel || 'Zusatzprodukt',
            title: card.dataset.variantTitle || 'Zusatzprodukt',
            unitPriceCents: Number.parseInt(card.dataset.variantPrice || '0', 10) || 0,
            qty: quantityPerTent * tentQty,
          };
        })
        .filter(Boolean);
    }

    function buildCartPermalink(origin, items, opts) {
      opts = opts || {};
      var propertiesB64 = opts.propertiesB64 || '';
      var checkoutQuery = opts.checkoutQuery || '';

      var line = (items || [])
        .filter(function (i) {
          return i.variantId && i.quantity;
        })
        .map(function (i) {
          return encodeURIComponent(i.variantId) + ':' + encodeURIComponent(i.quantity);
        })
        .join(',');

      var base = line ? origin + '/cart/' + line : origin + '/cart';

      var params = new URLSearchParams();
      if (propertiesB64) params.set('properties', propertiesB64);

      if (checkoutQuery) {
        var cq = new URLSearchParams(checkoutQuery);
        cq.forEach(function (v, k) {
          params.set(k, v);
        });
      }

      var qs = params.toString();
      return qs ? base + '?' + qs : base;
    }

    function buildCheckoutUrlFromAcceptUrl(acceptUrl) {
      if (!acceptUrl) return '';
      // Shopify: /cart/<items>?...&checkout -> direkt Checkout mit diesen Items
      return acceptUrl + (acceptUrl.indexOf('?') >= 0 ? '&checkout' : '?checkout');
    }

    function makeOfferNumber(now) {
      var yy = String(now.getFullYear());
      var mm = String(now.getMonth() + 1).padStart(2, '0');
      var dd = String(now.getDate()).padStart(2, '0');
      var rnd = Math.floor(Math.random() * 9000 + 1000);
      return yy + mm + dd + '-' + rnd;
    }

    function money(cents, locale, currency) {
      var value = (cents || 0) / 100;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value);
      } catch (e) {
        return value.toFixed(2) + ' ' + (currency || 'EUR');
      }
    }

    function escapeHtml(str) {
      return String(str || '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    // =========================
    // Confirmation HTML
    // =========================
    function buildOfferConfirmHtml(d) {
      var SC = '</scr' + 'ipt>';
      var offerJson = JSON.stringify(d).replace(/</g, '\\u003c');

      var baseTotal = d.basePriceCents * d.tentQty;
      var wallTotal = (d.wallLines || []).reduce(function (sum, w) {
        return sum + (w.unitPriceCents || 0) * (w.qty || 0);
      }, 0);
      var configurationTotal = (d.configurationLines || []).reduce(function (sum, item) {
        return sum + (item.unitPriceCents || 0) * (item.qty || 0);
      }, 0);
      var cartTotal = (d.cartLines || []).reduce(function (sum, c) {
        return sum + (c.lineTotalCents || 0);
      }, 0);
      var grandTotal = baseTotal + wallTotal + configurationTotal + cartTotal;

      var wallRows = (d.wallLines || [])
        .map(function (w) {
          return (
            '<tr>' +
            '<td>Seitenwand: ' +
            escapeHtml(w.title) +
            '</td>' +
            '<td class="num">' +
            w.qty +
            '</td>' +
            '<td class="num">' +
            money(w.unitPriceCents, d.locale, d.currency) +
            '</td>' +
            '<td class="num">' +
            money((w.unitPriceCents || 0) * (w.qty || 0), d.locale, d.currency) +
            '</td>' +
            '</tr>'
          );
        })
        .join('');

      var configurationRows = (d.configurationLines || [])
        .map(function (item) {
          return (
            '<tr>' +
            '<td>' +
            escapeHtml(item.title) +
            '<div class="muted">' +
            escapeHtml(item.groupLabel) +
            '</div></td>' +
            '<td class="num">' +
            item.qty +
            '</td>' +
            '<td class="num">' +
            money(item.unitPriceCents, d.locale, d.currency) +
            '</td>' +
            '<td class="num">' +
            money((item.unitPriceCents || 0) * (item.qty || 0), d.locale, d.currency) +
            '</td>' +
            '</tr>'
          );
        })
        .join('');

      var cartRows = (d.cartLines || [])
        .map(function (c) {
          return (
            '<tr>' +
            '<td>' +
            escapeHtml(c.title) +
            '<div class="muted">Warenkorb</div></td>' +
            '<td class="num">' +
            c.qty +
            '</td>' +
            '<td class="num">' +
            money(c.unitPriceCents, d.locale, d.currency) +
            '</td>' +
            '<td class="num">' +
            money(c.lineTotalCents, d.locale, d.currency) +
            '</td>' +
            '</tr>'
          );
        })
        .join('');

      var jsqrUrl = d.assets && d.assets.jsqr ? d.assets.jsqr : '';
      var jspdfUrl = d.assets && d.assets.jspdf ? d.assets.jspdf : '';

      var c = d.contact || { enabled: false };
      var contactRows = [];
      if (c.enabled) {
        if (c.company) contactRows.push('<tr><td class="muted">Firma</td><td>' + escapeHtml(c.company) + '</td></tr>');
        if (c.name) contactRows.push('<tr><td class="muted">Name</td><td>' + escapeHtml(c.name) + '</td></tr>');
        else {
          if (c.firstname)
            contactRows.push('<tr><td class="muted">Vorname</td><td>' + escapeHtml(c.firstname) + '</td></tr>');
          if (c.lastname)
            contactRows.push('<tr><td class="muted">Name</td><td>' + escapeHtml(c.lastname) + '</td></tr>');
        }
        if (c.email) contactRows.push('<tr><td class="muted">E-Mail</td><td>' + escapeHtml(c.email) + '</td></tr>');
        if (c.address1)
          contactRows.push('<tr><td class="muted">Adresse</td><td>' + escapeHtml(c.address1) + '</td></tr>');

        var cityLine = [c.zip, c.city].filter(Boolean).join(' ');
        if (cityLine)
          contactRows.push('<tr><td class="muted">PLZ / Stadt</td><td>' + escapeHtml(cityLine) + '</td></tr>');

        if (c.country) contactRows.push('<tr><td class="muted">Land</td><td>' + escapeHtml(c.country) + '</td></tr>');
      }

      var contactHtml =
        c.enabled && contactRows.length
          ? '<div class="card" style="margin-top:12px">' +
            '<div class="card__title">Kontaktdaten</div>' +
            '<table><tbody>' +
            contactRows.join('') +
            '</tbody></table>' +
            '</div>'
          : '';

      return `<!doctype html>
<html lang="de">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>Angebot ${escapeHtml(d.offerNo)}</title>

  <style>
    :root{
      --bg:#01292C; --card:rgb(245,245,247); --text:#0b0b0c; --muted:rgba(0,0,0,.62);
      --border:#d2d2d7; --brand:rgb(0,118,223); --radius:18px;
    }
    *{box-sizing:border-box}
    body{margin:0;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;background:var(--bg);color:var(--text)}
    header{background:rgba(1,41,44,.72);backdrop-filter:blur(10px);border-bottom:1px solid rgba(255,255,255,.14)}
    .header__inner{max-width:1120px;margin:0 auto;padding:18px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px}
    .logo img{height:24px;width:auto;display:block}
    .meta{text-align:right;font-size:12px;line-height:1.3;color:rgba(255,255,255,.72)}
    .meta strong{color:rgba(255,255,255,.95);font-weight:650}
    main{max-width:1120px;margin:0 auto;padding:22px 16px 44px}
    .shell{display:grid;grid-template-columns:1fr 360px;gap:18px;align-items:start}
    .frame{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);border-radius:22px;padding:12px}
    .card{background:var(--card);border-radius:var(--radius);padding:18px}
    .success{display:flex;gap:12px;align-items:flex-start}
    .success__icon{width:46px;height:46px;flex:0 0 46px;border-radius:999px;border:2px solid var(--brand);display:grid;place-items:center;color:var(--brand);background:#fff}
    .success__title{margin:0;font-size:22px;line-height:1.15;letter-spacing:-0.01em;font-weight:600}
    .muted{color:var(--muted);font-size:13px;line-height:1.45;margin-top:6px}
    .variantLine{margin-top:6px;font-size:13px;line-height:1.35;color:rgba(0,0,0,.78)}
    .note{margin-top:12px;color:var(--muted);font-size:12.5px;line-height:1.35}
    .actions{display:flex;flex-wrap:wrap;gap:10px}
    .btn{appearance:none;border:1px solid var(--border);background:#fff;color:var(--text);border-radius:999px;padding:10px 14px;font-size:13px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;text-decoration:none}
    .btn--primary{background:var(--brand);border-color:var(--brand);color:#fff}
    .btn[disabled]{opacity:.55;cursor:not-allowed}
    .actionsRow{margin-top:14px;display:flex;gap:14px;align-items:flex-start;justify-content:space-between}
    .qrBox{flex:0 0 128px;display:flex;flex-direction:column;align-items:center;gap:8px}
    .qrBox canvas{width:110px;height:110px;border-radius:14px;background:#fff;border:1px solid var(--border);padding:6px;display:block}
    .card__title{font-weight:650;font-size:13px;margin-bottom:10px;color:rgba(0,0,0,.78)}
    table{width:100%;border-collapse:collapse}
    th,td{padding:10px 6px;border-bottom:1px solid var(--border);font-size:12.5px;vertical-align:top}
    th{text-align:left;color:rgba(0,0,0,.72);font-weight:650}
    .num{text-align:right;white-space:nowrap}
    @media (max-width:980px){.shell{grid-template-columns:1fr}}
    @media (max-width:560px){.actionsRow{flex-direction:column}.qrBox{align-items:flex-start}.qrBox canvas{width:128px;height:128px}}
    @media print{header,.actionsRow{display:none!important}main{padding:0;background:#fff}body{background:#fff}}
    /* Desktop/Default */
/* Nur für .ctable */
table.ctable {
  width: 100%;
  border-collapse: collapse;
}
table.ctable th,
table.ctable td {
  padding: 10px 8px;
  vertical-align: top;
}
table.ctable th.num,
table.ctable td.num {
  text-align: right;
  white-space: nowrap;
}

/* Mobile: Table -> Stacked rows (nur .ctable) */
@media (max-width: 640px) {
  table.ctable thead {
    display: none;
  }

  table.ctable,
  table.ctable tbody,
  table.ctable tr,
  table.ctable td {
    display: block;
    width: 100%;
  }

  table.ctable tr {
    border-top: 1px solid #e5e5e5;
    padding: 10px 0;
  }

  /* 1. Spalte (Position) volle Breite */
  table.ctable td:first-child {
    padding: 0 0 8px;
  }

  /* Zahlen-Spalten als "Label : Wert" */
  table.ctable td.num {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    padding: 6px 0;
    white-space: normal;
    text-align: left; /* auf mobile sinnvoll, weil flex */
  }

  table.ctable td.num::before {
    font-weight: 600;
    color: #6b7280;
    text-align: left;
    flex: 0 0 42%;
  }

  table.ctable td:nth-child(2)::before { content: "Menge"; }
  table.ctable td:nth-child(3)::before { content: "Einzelpreis"; }
  table.ctable td:nth-child(4)::before { content: "Summe"; }

  /* Lange Variantentexte sauber umbrechen */
  table.ctable .variantLine {
    overflow-wrap: anywhere;
    word-break: break-word;
    margin-top: 4px;
  }
  table.ctable .muted {
    margin-top: 4px;
  }
}
  </style>
</head>

<body>
  <header>
    <div class="header__inner">
      <a class="logo" href="${escapeHtml(d.origin)}" aria-label="Zurück zum Shop">
        <img src="https://cdn.shopify.com/s/files/1/1032/8191/8291/files/stormtent-logo-yellow.webp?v=1771363013" alt="Stormtent">
      </a>
      <div class="meta">
        <div>Datum: <strong>${escapeHtml(d.dateStr)}</strong></div>
        <div>Angebotsnr.: <strong>${escapeHtml(d.offerNo)}</strong></div>
      </div>
    </div>
  </header>

  <main>
    <div class="frame">
      <div class="shell">
        <section>
          <div class="card">
            <div class="success">
              <div class="success__icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div style="flex:1 1 auto;">
                <h1 class="success__title">Angebot erstellt</h1>
                <div class="muted">Sie können Ihr Angebot als PDF speichern.</div>

                <div class="actionsRow" aria-label="Aktionen">
                  <div class="actions">
                    <button class="btn btn--primary" type="button" data-download-pdf>PDF herunterladen</button>
                    <a class="btn" href="${escapeHtml(d.checkoutUrl || d.acceptUrl)}">Checkout</a>
                  </div>

                  <div class="qrBox" aria-label="QR-Code">
                    <div class="muted" style="margin:0">QR-Code</div>
                    <canvas id="offer-qr-canvas" width="220" height="220"></canvas>
                    <div id="offer-qr-error" class="muted" style="margin:0;display:none;text-align:center"></div>
                  </div>
                </div>

                <div class="note">Hinweis: Das Angebot bleibt 2 Monate gültig.</div>
              </div>
            </div>
          </div>

          <div class="card" style="margin-top:12px">
            <div class="card__title">Positionen</div>
            <table class="ctable">
              <thead>
                <tr>
                  <th>Position</th>
                  <th class="num">Menge</th>
                  <th class="num">Einzelpreis</th>
                  <th class="num">Summe</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    ${escapeHtml(d.productTitle)}
                    ${
                      d.selectedVariantText
                        ? '<div class="variantLine">' + escapeHtml(d.selectedVariantText) + '</div>'
                        : ''
                    }
                    <div class="muted">Basis</div>
                  </td>
                  <td class="num">${d.tentQty}</td>
                  <td class="num">${money(d.basePriceCents, d.locale, d.currency)}</td>
                  <td class="num">${money(baseTotal, d.locale, d.currency)}</td>
                </tr>
                ${wallRows}
                ${configurationRows}
                ${cartRows}
              </tbody>
            </table>

            <div class="note">Versandkosten werden im Checkout berechnet.</div>
          </div>
        </section>

        <aside>
          <div class="card">
            <div class="card__title">Übersicht</div>
            <table>
              <tbody>
                <tr>
                  <td class="muted">Zwischensumme</td>
                  <td class="num">${money(
                    baseTotal + wallTotal + configurationTotal + cartTotal,
                    d.locale,
                    d.currency
                  )}</td>
                </tr>
                <tr>
                  <td class="muted"><strong>Gesamt</strong></td>
                  <td class="num"><strong>${money(grandTotal, d.locale, d.currency)}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>

          ${contactHtml}
        </aside>
      </div>
    </div>

    <script>window.__offer_asset_errors__=[];${SC}
    <script src="${escapeHtml(jsqrUrl)}" onerror="window.__offer_asset_errors__.push('jsqr')">${SC}
    <script src="${escapeHtml(jspdfUrl)}" onerror="window.__offer_asset_errors__.push('jspdf')">${SC}

    <script>
      (function(){
        var OFFER = ${offerJson};

        var acceptUrl = OFFER.acceptUrl || '';
        var checkoutUrl = OFFER.checkoutUrl || (acceptUrl ? (acceptUrl + (acceptUrl.indexOf('?')>=0 ? '&checkout' : '?checkout')) : '');

        var btnPrint = document.querySelector('[data-print]');
        var btnPdf = document.querySelector('[data-download-pdf]');
        var qrCanvasEl = document.getElementById('offer-qr-canvas');
        var qrErrEl = document.getElementById('offer-qr-error');

        function showQrError(msg){
          if (qrCanvasEl) qrCanvasEl.style.display = 'none';
          if (qrErrEl) { qrErrEl.textContent = msg || 'QR Fehler'; qrErrEl.style.display = 'block'; }
        }

        async function qrToCanvas(canvas, text){
          if (window.__offer_asset_errors__ && window.__offer_asset_errors__.includes('jsqr')) {
            throw new Error('jsqr.min.js konnte nicht geladen werden.');
          }
          var JSQR = window.JSQR;
          if (!JSQR) throw new Error('JSQR not available (window.JSQR fehlt).');

          var enc = new JSQR();
          var MODE = enc.ENCODE_MODE || JSQR.prototype.ENCODE_MODE;
          var EC   = enc.ERROR_CORRECTION || JSQR.prototype.ERROR_CORRECTION;
          var CodeCtor = enc.Code || JSQR.prototype.Code;

          if (!MODE || !MODE.UTF8) throw new Error('JSQR ENCODE_MODE missing');
          if (!EC || EC.M === undefined) throw new Error('JSQR ERROR_CORRECTION missing');
          if (typeof CodeCtor !== 'function') throw new Error('JSQR Code constructor missing');

          var code = new CodeCtor(MODE.UTF8, 0, EC.M);
          var matrix = enc.encode(text, code);

          var desired = 220;
          matrix.margin = 1;

          var len = Number(matrix.length) || 0;
          var cells = Math.max(1, len + (matrix.margin << 1));
          matrix.scale = Math.max(1, Math.floor(desired / cells));

          var size = cells * matrix.scale;
          canvas.width = size; canvas.height = size;

          var ctx = canvas.getContext('2d');
          ctx.clearRect(0,0,size,size);
          ctx.fillStyle = '#fff'; ctx.fillRect(0,0,size,size);
          ctx.fillStyle = '#000';
          matrix.draw(canvas, 0, 0);
        }

        (async function(){
          try { if (acceptUrl) await qrToCanvas(qrCanvasEl, acceptUrl); }
          catch(e){ console.warn(e); showQrError(e.message || String(e)); }
        })();

        function downloadBlob(blob, fileName){
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url; a.download = fileName;
          document.body.appendChild(a);
          a.click(); a.remove();
          setTimeout(function(){ URL.revokeObjectURL(url); }, 2500);
        }

        function fmtMoneyCents(cents) {
          var v = (cents || 0) / 100;
          try {
            return new Intl.NumberFormat(OFFER.locale || 'de-DE', {
              style: 'currency',
              currency: OFFER.currency || 'EUR',
            }).format(v);
          } catch (e) {
            return v.toFixed(2) + ' ' + (OFFER.currency || 'EUR');
          }
        }

        function buildRows() {
          var rows = [];
          var baseTotal = (OFFER.basePriceCents || 0) * (OFFER.tentQty || 1);

          var baseLabel = (OFFER.productTitle || 'Produkt');
          if (OFFER.selectedVariantText) baseLabel += ' - ' + OFFER.selectedVariantText;
          baseLabel += ' (Basis)';

          rows.push({ label: baseLabel, qty: (OFFER.tentQty || 1), unitCents: (OFFER.basePriceCents || 0), sumCents: baseTotal });

          (OFFER.wallLines || []).forEach(function(w){
            rows.push({
              label: 'Seitenwand: ' + (w.title || 'Seitenwand'),
              qty: (w.qty || 0),
              unitCents: (w.unitPriceCents || 0),
              sumCents: (w.unitPriceCents || 0) * (w.qty || 0),
            });
          });

          (OFFER.configurationLines || []).forEach(function(item){
            rows.push({
              label: (item.groupLabel ? item.groupLabel + ': ' : '') + (item.title || 'Zusatzprodukt'),
              qty: (item.qty || 0),
              unitCents: (item.unitPriceCents || 0),
              sumCents: (item.unitPriceCents || 0) * (item.qty || 0),
            });
          });

          (OFFER.cartLines || []).forEach(function(c){
            rows.push({
              label: (c.title || 'Artikel') + ' (Warenkorb)',
              qty: (c.qty || 0),
              unitCents: (c.unitPriceCents || 0),
              sumCents: (c.lineTotalCents || 0),
            });
          });

          return rows;
        }

      function loadImageAsDataUrl(url) {
        return new Promise(function(resolve, reject) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              var canvas = document.createElement('canvas');
              canvas.width = img.naturalWidth;
              canvas.height = img.naturalHeight;
              var ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);
              resolve({ dataUrl: canvas.toDataURL('image/png'), width: img.naturalWidth, height: img.naturalHeight });
            } catch (e) { reject(e); }
          };
          img.onerror = function() { reject(new Error('Bild konnte nicht geladen werden')); };
          img.src = url;
        });
      }

      async function buildPdfBlobJsPDF() {
        if (window.__offer_asset_errors__ && window.__offer_asset_errors__.includes('jspdf')) {
          throw new Error('jsPDF konnte nicht geladen werden.');
        }
        if (!window.jspdf || !window.jspdf.jsPDF) throw new Error('jsPDF nicht verfügbar');

        const { jsPDF } = window.jspdf;
        const doc = new jsPDF({ unit: 'mm', format: 'a4' });
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();
        const BRAND = [1, 41, 44];
        const ml = 20;
        const mr = 20;
        const contentW = pageW - ml - mr;
        const rows = buildRows();
        let y = 0;

        // ─── Akzentlinie oben (bis zum Logo-Bereich) ──────
        doc.setFillColor(...BRAND);
        doc.rect(0, 0, pageW, 26, 'F');  // reicht bis unter das Logo
        y = 10;

        // ─── LOGO (oben links, im Akzentbalken) ───────────
        var logoUrl = OFFER.assets && OFFER.assets.logo ? OFFER.assets.logo : '';
        var logoEndX = ml;
        if (logoUrl) {
          try {
            var logoData = await loadImageAsDataUrl(logoUrl);
            var targetH = 6;
            var aspect = logoData.width / logoData.height;
            var targetW = targetH * aspect;
            doc.addImage(logoData.dataUrl, 'PNG', ml, y, targetW, targetH);
            logoEndX = ml + targetW + 8;
          } catch (e) {
            console.warn('Logo konnte nicht geladen werden:', e);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(16);
            doc.setTextColor(255, 255, 255);
            doc.text('STORMTENT', ml, y + 5);
            logoEndX = ml + 45;
          }
        } else {
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(16);
          doc.setTextColor(255, 255, 255);
          doc.text('STORMTENT', ml, y + 5);
          logoEndX = ml + 45;
        }

        y = 30;

        // ─── QR-CODE (rechts, unter Trennlinie) ────────────
        var qrSize = 26;
        var qrX = pageW - mr - qrSize;
        var qrY = y + 4;
        try {
          if (qrCanvasEl && acceptUrl) {
            var qrData = qrCanvasEl.toDataURL('image/png');
            doc.addImage(qrData, 'PNG', qrX, qrY, qrSize, qrSize);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(6.5);
            doc.setTextColor(150);
            doc.text('Angebot annehmen', qrX + qrSize / 2, qrY + qrSize + 3.5, { align: 'center' });
            doc.setFontSize(6);
            doc.setTextColor(0, 113, 227);
            doc.textWithLink('Checkout', qrX + qrSize / 2, qrY + qrSize + 7, { url: checkoutUrl || acceptUrl, align: 'center' });
          }
        } catch (e) { /* QR optional */ }
        y += 6;

        // ─── ANGEBOT Titel ─────────────────────────────────
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor(29, 29, 31);
        doc.text('Angebot', ml, y);
        y += 10;

        // ─── Meta links ────────────────────────────────────
        var metaStartY = y;
        var metaLabelX = ml;
        var metaValueX = ml + 25;
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(130);
        doc.text('Angebotsnr.', metaLabelX, y);
        doc.text('Datum', metaLabelX, y + 6);
        doc.text('Gesamt', metaLabelX, y + 12);
        doc.setTextColor(30);
        doc.text(OFFER.offerNo || '', metaValueX, y);
        doc.text(OFFER.dateStr || '', metaValueX, y + 6);
        doc.text(fmtMoneyCents(rows.reduce(function(s, r) { return s + (r.sumCents || 0); }, 0)), metaValueX, y + 12);

        y = metaStartY + 26;

        // ─── Trennlinie zwischen Meta und Adressen ────────
        doc.setDrawColor(220);
        doc.setLineWidth(0.15);
        doc.line(ml, y, pageW - mr, y);
        y += 8;

        // ─── Firma links / Empfänger rechts ────────────────
        var addrY = y;

        // Firma links
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.setTextColor(30);
        doc.text('NextFuture GmbH', ml, addrY);
        doc.setFont('helvetica', 'normal');
        doc.text('info@stormtent.de', ml, addrY + 5);
        doc.text('Robert-Perthel-Str. 12c', ml, addrY + 10);
        doc.text('50739 Köln', ml, addrY + 15);
        doc.text('Deutschland', ml, addrY + 20);

        // Empfänger rechts
        var ct = OFFER.contact || { enabled: false };
        if (ct.enabled) {
            var rx = pageW / 2 - 40;
          var ry = addrY;
          var recipientLines = [];
          if (ct.company) recipientLines.push(ct.company);
          if (ct.name) recipientLines.push(ct.name);
          else {
            var fullName = [ct.firstname, ct.lastname].filter(Boolean).join(' ');
            if (fullName) recipientLines.push(fullName);
          }
          if (ct.address1) recipientLines.push(ct.address1);
          var cityLine = [ct.zip, ct.city].filter(Boolean).join(' ');
          if (cityLine) recipientLines.push(cityLine);
          if (ct.country) recipientLines.push(ct.country);
          recipientLines.forEach(function(line, i) {
            doc.setFont('helvetica', i === 0 ? 'bold' : 'normal');
            doc.setFontSize(9);
            doc.setTextColor(30);
            doc.text(String(line), rx, ry);
            ry += 5;
          });
        }

        y = addrY + 25;

        // ─── Trennlinie dünn ───────────────────────────────
        doc.setDrawColor(220);
        doc.setLineWidth(0.15);
        doc.line(ml, y, pageW - mr, y);
        y += 16;

        // ─── TABELLE ───────────────────────────────────────
        var colX = {
          pos: ml + 3,
          desc: ml + contentW * 0.42,
          price: pageW - mr - 56,
          qty: pageW - mr - 30,
          sum: pageW - mr - 2,
        };

        // Tabellenkopf (weiß, nur Trennlinie darunter)
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
        doc.text('Artikelbezeichnung', colX.pos, y + 1);
        doc.text('Einzelpreis', colX.price, y + 1, { align: 'right' });
        doc.text('Menge', colX.qty, y + 1, { align: 'right' });
        doc.text('Summe', colX.sum, y + 1, { align: 'right' });
        y += 8;

        // Tabellenzeilen
        rows.forEach(function(row, idx) {
          var rowH = 14;

          // Trennlinie
          doc.setDrawColor(230);
          doc.setLineWidth(0.1);
          doc.line(ml, y - 5, pageW - mr, y - 5);

          // Artikelbezeichnung (ggf. umbrechen)
          var maxLabelW = colX.desc - colX.pos - 4;
          var labelLines = doc.splitTextToSize(String(row.label || ''), maxLabelW);
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8.5);
          doc.setTextColor(30);
          doc.text(labelLines, colX.pos, y);


          // Zahlen
          doc.setFontSize(8.5);
          doc.setTextColor(30);
          doc.text(fmtMoneyCents(row.unitCents), colX.price, y, { align: 'right' });
          doc.text(String(row.qty), colX.qty, y, { align: 'right' });
          doc.setFont('helvetica', 'bold');
          doc.text(fmtMoneyCents(row.sumCents), colX.sum, y, { align: 'right' });

          rowH = Math.max(14, labelLines.length * 4.5 + 6);
          y += rowH;
        });

        // Trennlinie unter Tabelle
        doc.setDrawColor(...BRAND);
        doc.setLineWidth(0.4);
        doc.line(ml, y - 4, pageW - mr, y - 4);
        y += 6;

        // ─── SUMMEN (rechts) ───────────────────────────────
        var grandTotal = rows.reduce(function(s, r) { return s + (r.sumCents || 0); }, 0);

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor(130);
        doc.text('Zwischensumme', colX.price, y, { align: 'right' });
        doc.setTextColor(30);
        doc.text(fmtMoneyCents(grandTotal), colX.sum, y, { align: 'right' });
        y += 8;

        doc.setDrawColor(220);
        doc.line(pageW - mr - 80, y - 3, pageW - mr, y - 3);
        y += 4;

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.setTextColor(...BRAND);
        doc.text('Gesamt', colX.price, y + 1, { align: 'right' });
        doc.text(fmtMoneyCents(grandTotal), colX.sum, y + 1, { align: 'right' });
        y += 16;


        // ─── HINWEIS ───────────────────────────────────────
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.5);
        doc.setTextColor(160);
        doc.text('Versandkosten werden im Checkout berechnet.', ml, y);

        return doc.output('blob');
      }
        btnPdf && btnPdf.addEventListener('click', async function(){
          var original = btnPdf.textContent;
          try {
            btnPdf.disabled = true;
            btnPdf.textContent = 'Erstelle PDF...';
            var blob = await buildPdfBlobJsPDF();
            downloadBlob(blob, 'Angebot-' + (OFFER.offerNo || 'ANG') + '.pdf');
          } catch(e) {
            console.error(e);
            alert('PDF konnte nicht erzeugt werden: ' + (e.message || e));
          } finally {
            btnPdf.disabled = false;
            btnPdf.textContent = original;
          }
        });

      })();
    ${SC}
  </main>
</body>
</html>`;
    }
  })();

  // =========================
  // CLOSE modal
  // =========================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qr-offer-close]');
    if (!btn) return;
    var details = btn.closest('details.qr-offer');
    if (details) details.open = false;
  });
  (function () {
    var fullscreenClass = 'is-fullscreen';
    var previousFocus = null;

    function getCurrentIndex(scroller) {
      var slides = scroller.querySelectorAll('.product__media-wrapper--hero');
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - scroller.scrollLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function scrollToIndex(container, index) {
      requestAnimationFrame(function () {
        var scroller = container.querySelector('.product__gallery-scroll');
        var slides = scroller.querySelectorAll('.product__media-wrapper--hero');

        if (slides[index]) {
          scroller.scrollLeft = slides[index].offsetLeft;
        }
      });
    }

    function openGallery(container) {
      var scroller = container.querySelector('.product__gallery-scroll');
      var index = getCurrentIndex(scroller);
      var closeButton = container.querySelector('.product__gallery-fullscreen-close');

      previousFocus = document.activeElement;

      if (!closeButton) {
        closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'product__gallery-fullscreen-close';
        closeButton.setAttribute('aria-label', 'Galerie schließen');
        closeButton.textContent = '×';
        container.appendChild(closeButton);
      }

      container.classList.add(fullscreenClass);
      container.setAttribute('role', 'dialog');
      container.setAttribute('aria-modal', 'true');
      document.body.classList.add('gallery-fullscreen-open');

      scrollToIndex(container, index);
      closeButton.focus({ preventScroll: true });
    }

    function closeGallery(container) {
      var scroller = container.querySelector('.product__gallery-scroll');
      var index = getCurrentIndex(scroller);

      container.classList.remove(fullscreenClass);
      container.removeAttribute('role');
      container.removeAttribute('aria-modal');
      document.body.classList.remove('gallery-fullscreen-open');

      scrollToIndex(container, index);

      if (previousFocus && previousFocus.focus) {
        previousFocus.focus({ preventScroll: true });
      }
    }

    document.addEventListener('click', function (event) {
      var closeButton = event.target.closest('.product__gallery-fullscreen-close');

      if (closeButton) {
        closeGallery(closeButton.closest('.product__gallery-container'));
        return;
      }

      var image = event.target.closest('.product__media--hero');
      if (!image) return;

      var container = image.closest('.product__gallery-container');

      if (container && !container.classList.contains(fullscreenClass)) {
        openGallery(container);
      }
    });

    document.addEventListener('keydown', function (event) {
      var container = document.querySelector('.product__gallery-container.is-fullscreen');

      if (!container) return;

      if (event.key === 'Escape') {
        closeGallery(container);
      }

      if (event.key === 'ArrowLeft') {
        container.querySelector('.product__gallery-arrow--left')?.click();
      }

      if (event.key === 'ArrowRight') {
        container.querySelector('.product__gallery-arrow--right')?.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
